var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.802,
    height: 29.802,
    viewBox: "0 0 29.802 29.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1291d9",
    d: "M14.9 0A14.9 14.9 0 1 1 0 14.9 14.9 14.9 0 0 1 14.9 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M441.048 246.711a3.622 3.622 0 0 0-1.128-2.839 4.582 4.582 0 0 0-2.586-1.03l-1.575-.233a3.089 3.089 0 0 1-1.555-.642 1.645 1.645 0 0 1-.525-1.283c0-1.225.894-2.158 2.528-2.158a4.357 4.357 0 0 1 2.445.619.9.9 0 0 0 1.125-.1l.043-.042a.917.917 0 0 0-.134-1.421 5.557 5.557 0 0 0-2.582-.846v-1.87a.781.781 0 1 0-1.563 0v1.871c-2.447.254-3.912 1.82-3.912 4.023a3.444 3.444 0 0 0 1.011 2.645 4.742 4.742 0 0 0 2.625 1.108l1.633.233a2.407 2.407 0 0 1 1.517.583 1.863 1.863 0 0 1 .544 1.439c0 1.341-1.05 2.119-2.858 2.119a4.773 4.773 0 0 1-2.958-.825.933.933 0 0 0-1.2.109l-.077.076a.921.921 0 0 0 .1 1.4 6.27 6.27 0 0 0 3.562 1.113v1.365a.781.781 0 1 0 1.563 0v-1.421c2.36-.322 3.957-1.762 3.957-3.993z",
    transform: "translate(-421.425 -228.596)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarBlue);
export default __webpack_public_path__ + "static/media/dollar_blue.d9a8164b.svg";
export { ForwardRef as ReactComponent };